import { useState, useEffect, useRef } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetail, setDetailParams } from "../../state/puritySlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";


const CreatePurityMaster = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { detailParams, isNewEntry } = useSelector((state) => state.purity);
  const [submitBtnId, setSubmitBtnId] = useState("")
  const submitLockRef = useRef(false);//
  const [formData, setFormData] = useState({
    Q_Code: "",
    Q_Name: "",
    Q_Group: "",
    Q_Ord: "",
  });

  const { data: purityDetails = [], isPending: isLoading, mutate: filterDetail } = usePost({
    url: apiRoute.purity.getpurityforupdate,
    queryKey: "fetchPurityById",
  });

  // Fetch data when `detailParams?.Q_Code` exists
  useEffect(() => {
    if (detailParams && Object.keys(detailParams).length > 0) {
      console.log(detailParams)
      filterDetail({
        data: {
          Q_Code: detailParams.Q_Code
        }
      })
    }
  }, [detailParams]);

  useEffect(() => {
    if (!isNewEntry && purityDetails && Object.keys(purityDetails).length > 0) {
      setFormData({
        Q_Code: purityDetails.Q_Code || "",
        Q_Name: purityDetails.Q_Name || "",
        Q_Group: purityDetails.Q_Group || "",
        Q_Ord: purityDetails.Q_Ord || "",
      });
      console.log(purityDetails.Q_Code, isNewEntry, formData)

    }
  }, [purityDetails]);



  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const { mutate: addupdatePurity, isPending, isError } = usePost({
    queryKey: "Purity",
    url: apiRoute.purity.addupdatePurity,
    successMessage: "purity saved successfully!",
    onSuccessTasks: () => {
      dispatch(resetDetail());
      submitLockRef.current = false;
      if (submitBtnId == 'btnSaveNew') {
        setFormData({
          Q_Code: "",
          Q_Name: "",
          Q_Group: "",
          Q_Ord: "",
        })
      }
      else
        navigate(linksUrl.diamondParamater.purity.purityMaster);
    },
  });

  const onSuccessChkDupCode = (data) => {
    let isDuplicate = 0
    if (!submitLockRef.current) return; // 🚫 ignore stale calls
    if (isNewEntry && data && data.length > 0) {

      if (data[0].count > 0) {
        if (!toast.isActive("toast_chkqid")) {
          toast.error(`Duplicate Purity Code Found`, {
            "position": "top-center",
            "className": "toast-error",
            toastId: "toast_chkqid"
          })
        }
        isDuplicate = 1
        setFormData({ ...formData, Q_Code: "" })
        submitLockRef.current = false;
      }
    }
    if (isDuplicate === 0) {
      addupdatePurity({
        data: {
          ...formData,
          UID: user.username,
          pRecStatus: 2,
        }
      });

    }
  }
  const { mutate: funChkDuplicateQCode } = usePost({
    queryKey: "checkPurityCode",
    url: apiRoute.purity.checkPurityCode,
    onSuccessTasks: onSuccessChkDupCode
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitBtnId(e.nativeEvent.submitter.id)
    if (!formData.Q_Code.trim() || !formData.Q_Name.trim()) {
      toast.warn("Q_Code and Q_Name are required.");
      return;
    }
    if (submitLockRef.current) return;
    submitLockRef.current = true;
    if (isNewEntry) {
      funChkDuplicateQCode({
        data: {
          Q_Code: formData.Q_Code
        }
      })
    }
    if (!isNewEntry) {
      addupdatePurity({
        data: {
          ...formData,
          UID: user.username,
          pRecStatus: 1,
        }
      });
    }

  };

  const { data: ordData = [] } = useFetchWithBody({
    url: apiRoute.purity.getNextQuaOrd,
    queryKey: "getNextQuaOrd",
  });


  useEffect(() => {
    if (isNewEntry) {
      setFormData((prev) => ({
        ...prev,
        Q_Ord: ordData.getNextQuaOrd,
      }));
    }
  }, [isNewEntry, ordData]);
  if (isLoading || isPending) return <LoadingCard />;
  if (isError) return <ErrorCard />;

  return (
    <MainContainer
      pageName="Purity Entry"
      breadcrumbs={["Diamond Parameter", "Purity Master"]}
      prevPage={{ show: true, onClick: () => navigate(linksUrl.diamondParamater.purity.purityMaster) }}
    >
      <Card className="p-6">
        <CardBody>

          <form onSubmit={handleSubmit}>
            <div className="grid gap-4">

              <Input label="Purity Code" maxLength={10}
                readOnly={isNewEntry ? false : true}
                size="sm" name="Q_Code" value={formData.Q_Code} onChange={handleChange} isRequired />
              <h2 className="text-red-300 " style={{ fontSize: "0.7rem" }}>Purity code cannot be longer than 10 characters</h2>
              <Input label="Purity Name" size="sm" name="Q_Name" value={formData.Q_Name} onChange={handleChange} isRequired />
              <Input label="Purity Group" size="sm" name="Q_Group" value={formData.Q_Group} onChange={handleChange} />
              <Input label="Purity Order" size="sm" name="Q_Ord" type="number" value={formData.Q_Ord} onChange={handleChange} />
              <div className="flex gap-4 justify-center">
                <Button type="submit" id="btnSave" size="sm" color="primary" isLoading={isPending}>
                  {isNewEntry ? "Save" : "Update"}
                </Button>
                <Button
                  id="btnSaveNew"
                  color="success"
                  type="submit"
                  size="sm"
                  variant="shadow"
                  className="text-white"
                  startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                >
                  Save & New
                </Button>
              </div>

            </div>
          </form>


        </CardBody>
      </Card>
    </MainContainer>
  );
};

export default CreatePurityMaster;

